<template src="./NewFormCourse.html"></template>

<script>
import coursesService from "@/services/Courses";
import SearchIcon from "@/components/Icons/SearchIcon";
import locationService from "../../services/Locations";

export default {
  name: "NewFormCourse",
  data() {
    return {
      step: 1,
      coursesSelected: [],
      AllCoursesByInstitution: [],
      wordForSearchCourse: null,
      selectedCourse: null,
      age: {},
      location: {},
      capabilities: {},
      other: {},
      allGeneralCourses: [],
      arrayCourseToShow: [],
      ageOptions: [
        {
          name: "Rango",
          key: "range",
        },
        {
          name: "Edad específica",
          key: "specificAge",
        },
      ],
      stateOptions: [],
      citiesOptions: [],
      communeOptions: [],
      ageSelection: {
        name: "Rango",
        key: "range",
      },
      stateSelection: null,
      specificAge: null,
      coursesList: [
        {
          name: "nombre del curso",
        },
        {
          name: "nombre del curso",
        },
        {
          name: "nombre del curso",
        },
        {
          name: "nombre del curso",
        },
        {
          name: "nombre del curso",
        },
      ],
      inputTypeOptions: [
        {
          key: "Respuesta de texto corta",
          value: "shortText",
        },
        {
          key: "Respuesta de texto largo",
          value: "textLong",
        },
        {
          key: "Respuesta de opción única",
          value: "select",
        },
        {
          key: "Respuesta de opción múltiple",
          value: "multiSelect",
        },
        {
          key: "Respuesta alfanumérica",
          value: "number",
        },
        {
          key: "Fecha",
          value: "date",
        },
        {
          key: "Dirección",
          value: "addresses",
        },
        {
          key: "Correo",
          value: "mail",
        },
        {
          key: "Ubicación",
          value: "location",
        },
      ],
      newCapability: "",
      requirementData: {},
      dataStructure: {
        name: "example",
        personalInformation: [
          {
            inputType: "sex",
            required: true,
            question: "Sexo",
            answers: "girl",
          },
          {
            inputType: "age",
            required: true,
            question: {
              biggerThan: 18,
              lesserThan: 1,
            },
          },
          {
            inputType: "shortText",
            required: true,
            question: "Nombre",
          },
          {
            inputType: "shortText",
            required: true,
            question: "Apellidos",
          },
          {
            inputType: "number",
            required: true,
            question: "Número de documento de identidad",
          },
          {
            inputType: "select",
            required: true,
            question: "Tipo de documento",
            answers: [
              "Registro civil",
              "Tarjeta de identidad",
              "Cédula de ciudadanía",
              "Cédula extranjería",
              "Otro",
            ],
          },
          {
            inputType: "date",
            required: true,
            question: "Fecha de nacimiento",
          },
          {
            inputType: "select",
            required: true,
            question: "Pais de nacimiento",
            answers: ["Colombia", "Venezuela", "Panama", "Peru", "Otro"],
          },
          {
            inputType: "select",
            required: true,
            question: "Departamento de nacimiento",
            answers: [
              "Antioquia",
              "Bolivar",
              "Atlantico",
              "Cundinamarca",
              "Otro",
            ],
          },
          {
            inputType: "select",
            required: true,
            question: "Municipio de nacimiento",
            answers: ["Medellin", "Itagui", "Bello", "Envigado", "Otro"],
          },
        ],
        contactDetails: [
          {
            inputType: "mail",
            required: true,
            question: "Correo electrónico",
          },
          {
            inputType: "number",
            required: false,
            question: "Teléfono fijo",
          },
          {
            inputType: "number",
            required: true,
            question: "Teléfono celular",
          },
          {
            inputType: "number",
            required: true,
            question: "Otro número de contacto celular",
          },
          {
            inputType: "select",
            required: true,
            question: "Afiliación al Sistema General de Salud",
            answers: [
              "Contributivo",
              "Subsidiado",
              "Especial",
              "No tiene afiliación",
            ],
          },
        ],
        housingData: [
          {
            inputType: "select",
            required: true,
            question: "Estrato socioeconómico",
            answers: [
              "Uno (1)",
              "Dos (2)",
              "Tres (3)",
              "Cuatro (4)",
              "Cinco (5)",
              "Seis (6)",
              "Sin calificación",
            ],
          },
          {
            inputType: "select",
            required: true,
            question:
              "¿Cuál es el tipo de tenencia de la vivienda en la cual reside?",
            answers: ["Propia", "Arrendada", "Comodato", "Tenencia"],
          },
          {
            inputType: "select",
            required: true,
            question: "¿En su vivienda posee conexión a internet?",
            answers: ["Si", "No"],
          },
          {
            inputType: "select",
            required: true,
            question:
              "De los siguientes dispositivos ¿cuáles posee en su vivienda?",
            answers: [
              "Computador de mesa",
              "Computador portátil",
              "Tablet",
              "Celular inteligente",
              "Ninguna",
            ],
          },
          {
            inputType: "location",
            required: true,
            question: "Ubicación",
            answers: [
              {
                country: "Colombia",
                states: "Antioquia",
                city: "Medellín",
                commune: "Popular",
              },
            ],
            response: {
              country: "",
              states: "",
              city: "",
              commune: "",
            },
          },
          {
            inputType: "select",
            required: true,
            question: "Barrio, corregimiento o vereda",
            answers: ["Barrio 1", "Barrio 2", "Barrio 3", "Barrio 4"],
          },
          {
            inputType: "addresses",
            required: true,
            question: "Dirección",
          },
        ],
        studyData: [
          {
            inputType: "select",
            required: true,
            question: "¿Cuál es el último nivel académico aprobado?",
            answers: [
              "Ninguno",
              "Bachiller",
              "Técnica",
              "Tecnología",
              "Universitaria",
              "Maestría",
              "Doctorado",
            ],
          },
          {
            inputType: "multiSelect",
            required: true,
            question: "¿A qué se dedica actualmente?",
            answers: [
              "Estudiar",
              "Trabajar (tiempo completo)",
              "Trabajar (medio tiempo)",
              "Trabajar (ocasionalmente)",
              "Labores del hogar",
              "Ninguna de las anteriores",
              "Otra",
            ],
          },
          {
            inputType: "select",
            required: true,
            question: "¿Eres egresado de un municipio de medellin?",
            answers: ["Si", "No"],
          },
          {
            inputType: "select",
            required: true,
            question:
              "¿Cual de los siguientes niveles estas cursando en la educacicón pos secundario?",
            answers: [
              "diplomado",
              " cursos corto",
              " tecnica",
              " tecnica profesional",
              " tecnologia",
              " progama univertiario",
              " posgrado",
              " ninguno",
            ],
          },
        ],
        familyData: [
          {
            inputType: "number",
            required: true,
            question: "¿Cuántas personas dependen económicamente de usted?",
          },
          {
            inputType: "select",
            required: true,
            question: "¿Tiene hijos o hijas?",
            answers: ["Si", "No"],
          },
          {
            inputType: "select",
            required: true,
            question: "¿Es padre/madre soltera?",
            answers: ["Si", "No"],
          },
          {
            inputType: "number",
            required: true,
            question: "¿Cuántos hijos e hijas tiene?",
          },
          {
            inputType: "number",
            required: true,
            question: "¿Cuál es la edad de su primer hijo?",
          },
          {
            inputType: "select",
            required: true,
            question: "Actualmente, ¿es madre gestante o lactante?",
            answers: ["Gestante", "Lactante", "No aplica"],
          },
        ],
        populationData: [
          {
            inputType: "select",
            required: true,
            question:
              "¿Ha sido declarado(a) víctima de la violencia en Colombia?",
            answers: ["Si", "No"],
          },
          {
            inputType: "multiSelect",
            required: true,
            question:
              "¿Cuál es el hecho victimizante por el cual ha sido declarado víctima?",
            answers: [
              "Homicidio",
              "Desplazamiento forzado",
              "Tortura",
              "Secuestro",
              "Lesiones personales",
              "Desaparición forzada",
              "Reclutamiento ilegal de menores",
              "Mina antipersonal",
              "Amenazas",
              "Ninguno",
            ],
          },
          {
            inputType: "select",
            required: true,
            question: "Es una persona con discapacidad",
            answers: ["Si", "No"],
          },
          {
            inputType: "multiSelect",
            required: true,
            question: "¿Tiene alguna de las siguientes discapacidades?",
            answers: [
              "Motriz",
              "Visual",
              "Mental",
              "Auditiva",
              "Del lenguaje",
              "ninguna",
            ],
          },
          {
            inputType: "multiSelect",
            required: true,
            question: "¿Pertences a un Grupo étnico?",
            answers: [
              "Afrodescendiente (se preguntará grupo étnico)",
              "Indígena (se preguntará por etnia)",
              "Rom o gitano",
              "Ninguno",
            ],
          },
          {
            inputType: "select",
            required: true,
            question: "¿Se identifica como población LGTBIQ+?",
            answers: ["Si", "No"],
          },
          {
            inputType: "multiSelect",
            required: true,
            question: "¿Pertences a un Grupo étnico?",
            answers: [
              "Afrodescendiente (se preguntará grupo étnico)",
              "Indígena (se preguntará por etnia)",
              "Rom o gitano",
              "Ninguno",
            ],
          },
          {
            inputType: "select",
            required: true,
            question:
              "¿Cuál es el tipo de tenencia de la vivienda en la cual reside?",
            answers: ["Propia", "Arrendada", "Comodato", "Tenencia"],
          },
          {
            inputType: "multiSelect",
            required: true,
            question: "¿Cuál es su etnia?",
            answers: [
              "Afrocolombiano",
              "Raizal",
              "Palenquero",
              "Tule (Kuna)",
              "Embera (Dobidá, Eyabidá, Katío y Chamí)",
              "Sinú",
              "Ingas",
              "Kamsá",
              "Nasa (Paez)",
              "Pijaos",
              "Qu k. Chibcariwak",
              "illacingas Pastos",
              "Inga",
              "Nutabe",
              "Wayuu",
              " Kichwa",
              "Otro (Cuál)",
            ],
          },
        ],
        interestData: [
          {
            inputType: "textLong",
            required: false,
            question:
              "¿De qué modo estudiar puede ayudar a mejorar sus condiciones actuales de vida ?",
          },
          {
            inputType: "textLong",
            required: false,
            question:
              "¿Cuál fue la principal motivación para participar en @Medellín?",
          },
          {
            inputType: "select",
            required: true,
            question: "¿Por cual medio te enteraste de la convocatoria?",
            answers: [
              "redes sociales",
              "voz a voz",
              "dinamizadores territoriales",
              "pagina web de sapiencia",
              "pagina web de arroba medellin",
              "otras dependicas de la alcadia de medellin",
              "a traves de una Institución de educación superior",
            ],
          },
        ],
        capabilities: [
          {
            question:
              "Cuentas con las necesidades necesarias para el desarrollo de los cursos ofertados ?",
            inputType: "select",
            required: true,
            answers: ["Si", "No"],
          },
          {
            inputType: "questionsCapabilities",
            required: false,
            question: "questions",
            answers: [
              {
                question: "¿Sabe leer?",
              },
            ],
          },
        ],
        others: [
          {
            inputType: "textLong",
            required: false,
            question: "Pregunta",
          },
        ],
        important:
          "Diligenciar el formulario de forma correcta, verificando que los datos suministrados sean acertados",
        remember:
          "Los cursos son autogestionables con una duración y un plazo para desarrollarse de un mes a partir de la fecha de inicio.Te llegará un correo a la dirección con la que inscribiste anunciando si fuiste sellecionado o no La certificación se dará al aprobar el 80% de los contenidos",
        dataTreatment:
          "En observancia de la Ley 1581 de 2012, reglamentada parcialmente por el Decreto 1377 de 2013 y en la política de tratamiento de datos adoptado por SAPIENCIA, la importancia de la neutralidad de los medios tecnológicos y de comunicación, e interpretando todos estos de manera sistémica e integral en aras de la protección de los derechos y principios que circundan el Habeas Data y el Tratamiento de Datos Personales, se establecen las siguientes condiciones: 1) FINALIDAD DEL TRATAMIENTO DE LOS DATOS PERSONALES PARA PERSONA JURÍDICA Y NATURAL: a) el cumplimiento del lleno de requisitos formales para la suscripción de actas de compromiso y la posterior aplicación de los derechos y obligaciones que surgen entre las partes con ocasión de su suscripción. b) el cumplimiento de la Ley de Transparencia y el Derecho de Acceso a la Información Pública Nacional (Ley 1712 del 2014). c) La presentación de informes a los organismos de control. d) para la entrega de información a entidades cuyo objeto social y/o misional incluya la recolección de datos estadísticos, históricos y científicos. e) por  solicitud de autoridad judicial. Manifiesto que me informaron que, si soy menor de edad y/o en caso de recolección de mi información sensible, tengo derecho a contestar o no las preguntas que me formulen y a entregar o no los datos solicitados. Entiendo que son datos sensibles aquellos que afectan la intimidad del titular o cuyo uso indebido pueda generar discriminación (información étnica, racial, su orientación política, convicciones religiosas o filosóficas, la pertenencia a sindicatos, organizaciones sociales, de derechos humanos, así como los relativos a la salud, vida sexual y datos biométricos).Manifiesto que me informaron que los datos sensibles que se recolectarán serán utilizados para las finalidades descritas por la Agencia (Uso,recolección, actualización, transferencia) Nota: Cualquier uso de la información distinto a lo aquí establecido, no es aceptado ni permitido por SAPIENCIA. 2) AVISO DE PRIVACIDAD: Para los efectos de esta cláusula y del aviso de privacidad, se consideran datos sensibles aquellos que puedan revelar aspectos como origen racial o étnico, estado de salud presente y futura, información genética, creencias religiosas, filosóficas y morales, afiliación sindical, opiniones políticas, preferencia sexual y todos aquellos datos que puedan afectar la intimidad del titular o cuyo uso indebido pueda generar su discriminación. Respecto a estos SAPIENCIA se obliga al uso adecuado de los mismos en concordancia con la normativa vigente, la buena fe, el orden público y el presente Aviso. 3) MECANISMOS PARA LA PROTECCIÓN DE DATOS PERSONALES: ACCESO,RECTIFICACIÓN, CANCELACIÓN U OPOSICIÓN: la persona natural o jurídica Titular de Datos Personales puede solicitar a SAPIENCIA en cualquier momento, el acceso, la rectificación, la cancelación u oposición respecto a los datos personales que le conciernen, en este sentido, presentará su solicitud radicándola directamente en la Entidad o ingresando a la página web www.sapiencia.gov.co en la opción de Contáctenos o escribiendo al correo info@sapiencia.gov.co o comunicándose al teléfono en Medellín: (+57 4) 444 7947.",
      },
      take: 10,
      skip: 0,
    };
  },
  components: {
    SearchIcon,
  },
  methods: {
    updateInputType(index, section, value) {
      // Aquí puedes ejecutar el evento que quieras cuando cambie el valor del select
      console.log("El inputType del item " + index + " ha cambiado a " + value, 'data');
      this.dataStructure[section][index].inputType = value;
      if (value === "location") {
        this.dataStructure[section][index].answers = [
          {
            country: "Colombia",
            states: "Antioquia",
            city: "Medellín",
            commune: "Popular",
          },
        ];
      } else {
        this.dataStructure[section][index].answers = [];
      }
    },
    sampleFormat() {
      const dtf = new Intl.DateTimeFormat(this.locale);
      return dtf.format(new Date(2000, 11, 25, 12));
    },
    async loadMoreCourses() {
      this.take += 10;
      this.skip += 10;
      const moreCourses = await coursesService.getContinuosEducationCourses(this.take, this.skip);
      this.allGeneralCourses = this.allGeneralCourses.concat(moreCourses);
      this.courseToShow();
      await this.$store.dispatch('fetchLoading', false);
    },
    async getAllGeneralCourses() {
      try {
        this.allGeneralCourses = await coursesService.getContinuosEducationCourses(this.take, this.skip);
        this.courseToShow();
      } catch (e) {
        console.log("e", e);
      }
    },
    async createCourseForm() {
      try {
        await this.assingRequirementData();
        const response = await coursesService.createCourseForm(
          this.dataStructure
        );
        this.coursesSelected.map(async (element) => {
          await coursesService.linkEnrollFormWithCourse({
            formEnrollCourseId: response.id,
            courseId: element,
          });
        });
        await this.$router.push({ name: "AllFormsAcademic" });
        this.$buefy.toast.open({
          duration: 5000,
          message: "Formulario del curso creado correctamente",
          position: "is-bottom",
          type: "is-success",
        });
      } catch (e) {
        console.log("e", e);
      }
    },
    deleteQuestion(node, index) {
      this.dataStructure[node].splice(index);
    },
    deleteQuestionOption(node, indexQuestion, indexOption) {
      this.dataStructure[node][indexQuestion].answers.splice(indexOption, 1);
    },
    addQuestion(node) {
      this.dataStructure[node].push({
        inputType: "number",
        required: false,
        question: "Pregunta",
      });
    },
    addQuestionOption(node, indexQuestion) {
      // eslint-disable-next-line no-prototype-builtins
      if (!this.dataStructure[node][indexQuestion].hasOwnProperty("answers")) {
        this.$set(this.dataStructure[node][indexQuestion], "answers", []);
      }
      this.dataStructure[node][indexQuestion]["answers"].push("opción");
    },
    getRequirementData() {
      const requirementsKeys = [
        "sex",
        "age",
        "location",
        "questionsCapabilities",
      ];
      const self = this;
      Object.values(this.dataStructure).map((section) => {
        if (Array.isArray(section)) {
          section.map((element) => {
            requirementsKeys.map((key) => {
              if (element.inputType === key) {
                self.requirementData[key] = element;
              }
            });
          });
        }
      });
      this.requirementData.important = this.dataStructure.important;
      console.log("this", this.requirementData);
    },
    assingRequirementData() {
      const requirementsKeys = [
        "sex",
        "age",
        "location",
        "questionsCapabilities",
      ];
      const self = this;
      Object.values(this.dataStructure).map((section) => {
        if (Array.isArray(section)) {
          section.map((element) => {
            requirementsKeys.map((key) => {
              if (element.inputType === key) {
                element = self.requirementData[key];
              }
            });
          });
        }
      });
      this.dataStructure.important = this.requirementData.important;
    },
    addNewCapability() {
      this.requirementData.questionsCapabilities.answers.push({
        question: this.newCapability,
      });
      this.newCapability = "";
    },
    courseToShow() {
      if (this.wordForSearchCourse) {
        this.arrayCourseToShow = this.allGeneralCourses.filter((element) => {
          if (
            element.name.toLowerCase().includes(this.wordForSearchCourse.toLowerCase()) ||
            element.codigo.toString().includes(this.wordForSearchCourse)
          )
            return element;
        });
      } else {
        this.arrayCourseToShow = this.allGeneralCourses;
      }
    },
    async getStatesChange() {
      try {
        this.stateOptions = await locationService.getStates("Colombia");
      } catch (e) {
        console.error("error", e);
      }
    },
    async getCitiesChange(country, state) {
      try {
        if ((country, state)) {
          this.citiesOptions = await locationService.getCities(country, state);
        } else {
          this.citiesOptions = await locationService.getCities(
            "Colombia",
            "Antioquia"
          );
        }
      } catch (e) {
        console.error("error", e);
      }
    },
    async getCommunes() {
      this.communeOptions = await locationService.getCommunes();
    },
  },
  created() {
    this.getCommunes();
    this.getStatesChange();
    this.getCitiesChange();
  },
  mounted() {
    this.getAllGeneralCourses();
  },
  beforeMount() {
    this.getRequirementData();
  },
};
</script>

<style scoped lang="scss" src="./NewFormCourse.scss"></style>
